import { render, staticRenderFns } from "./OrderProviderCompareResults.vue?vue&type=template&id=8fe683b4&"
import script from "./OrderProviderCompareResults.vue?vue&type=script&lang=js&"
export * from "./OrderProviderCompareResults.vue?vue&type=script&lang=js&"
import style0 from "./OrderProviderCompareResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports